<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Registro de auditoría')"
      icono="mdi-clipboard-search-outline"
      tabla="regaud"
      :campos="['fechor+', 'id_ope+', 'acc+', 'tab', 'con', 'det']"
      :campos-filtrables="['fechor', 'id_ope', 'acc']"
      busqueda-rapida
      :filas-por-pagina="20"
      :zoom="0.92"
      dense
    >
      <template v-slot:[`item.fechor__VT`]="{ item }">
        <span style="white-space: nowrap">
          {{item.fechor__VT}}
        </span>
      </template>

      <template v-slot:[`item.det`]="{ item }">
          <span style="word-break: break-word;">{{ item.det }}</span>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
};
</script>

<style>
</style>